"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StandardsReportClient = void 0;
const dp_http_client_lib_1 = require("@greatmindsorg/dp-http-client-lib");
const sdk_constants_1 = require("../../constants/sdk.constants");
class StandardsReportClient {
    static newInstance(options, retryOptions) {
        return new StandardsReportClient(dp_http_client_lib_1.RetryableHttpClient.newInstance(options, retryOptions));
    }
    constructor(client) {
        this.client = client;
    }
    async assessmentsStandardReportOfItem(assessmentsStandardReportPayload, headers) {
        const response = await this.client.post(`${sdk_constants_1.AVR_API_PREFIX}/assessments.getItemStandards`, assessmentsStandardReportPayload, {
            headers,
        });
        return response.body.data;
    }
    async assessmentsStandardReportOfItemV2(assessmentsStandardReportPayload, headers) {
        const response = await this.client.post(`${sdk_constants_1.AVR_API_PREFIX}/v2/assessments.getItemStandards`, assessmentsStandardReportPayload, {
            headers,
        });
        return response.body.data;
    }
    async domainsPerCurriculumReport(domainsPerCurriculumReportPayloadDto, headers) {
        const response = await this.client.post(`${sdk_constants_1.AVR_API_PREFIX}/standards/schoolDomains.findByCurriculum`, domainsPerCurriculumReportPayloadDto, {
            headers,
        });
        return response.body.data;
    }
    async domainsPerCurriculumReportV2(domainsPerCurriculumReportPayloadDto, headers) {
        const response = await this.client.post(`${sdk_constants_1.AVR_API_PREFIX}/standards/v2/schoolDomains.findByCurriculum`, domainsPerCurriculumReportPayloadDto, {
            headers,
        });
        return response.body.data;
    }
    async performanceDistributionBySchools(performanceDistributionBySchoolPayloadDto, headers) {
        const response = await this.client.post(`${sdk_constants_1.AVR_API_PREFIX}/standards/assessments.performanceDistributionBySchools`, performanceDistributionBySchoolPayloadDto, {
            headers,
        });
        return response.body.data;
    }
    async performanceDistributionBySchoolsV2(performanceDistributionBySchoolPayloadDto, headers) {
        const response = await this.client.post(`${sdk_constants_1.AVR_API_PREFIX}/standards/v2/assessments.performanceDistributionBySchools`, performanceDistributionBySchoolPayloadDto, {
            headers,
        });
        return response.body.data;
    }
    async averageScorePerDomainStandardsReport(averageScoreOfDomainStandardsReportPayloadDto, headers) {
        const response = await this.client.post(`${sdk_constants_1.AVR_API_PREFIX}/standards/assessments.scoreSummary`, averageScoreOfDomainStandardsReportPayloadDto, {
            headers,
        });
        return response.body.data;
    }
    async averageScorePerDomainStandardsReportV2(averageScoreOfDomainStandardsReportPayloadDto, headers) {
        const response = await this.client.post(`${sdk_constants_1.AVR_API_PREFIX}/standards/v2/assessments.scoreSummary`, averageScoreOfDomainStandardsReportPayloadDto, {
            headers,
        });
        return response.body.data;
    }
    async scoreByStandardItems(scoreByStandardItemsPayloadDto, headers) {
        const response = await this.client.post(`${sdk_constants_1.AVR_API_PREFIX}/standards/assessments.scoreByStandardItems`, scoreByStandardItemsPayloadDto, {
            headers,
        });
        return response.body.data;
    }
    async scoreByStandardItemsV2(scoreByStandardItemsPayloadDto, headers) {
        const response = await this.client.post(`${sdk_constants_1.AVR_API_PREFIX}/standards/v2/assessments.scoreByStandardItems`, scoreByStandardItemsPayloadDto, {
            headers,
        });
        return response.body.data;
    }
    async performanceDistributionByClasses(performanceDistributionByClassesPayloadDto, headers) {
        const response = await this.client.post(`${sdk_constants_1.AVR_API_PREFIX}/standards/assessments.performanceDistributionByClasses`, performanceDistributionByClassesPayloadDto, {
            headers,
        });
        return response.body.data;
    }
}
exports.StandardsReportClient = StandardsReportClient;
//# sourceMappingURL=standard-report.client.js.map